import Arion from "@/assets/arion.svg?react";
import ISB from "@/assets/isb.svg?react";
import LBI from "@/assets/lbi.svg?react";
import Kvika from "@/assets/kvika.svg?react";
import Indo from "@/assets/indo.svg?react";

export const renderBankName = (paymentProvider: string): string => {
  switch (paymentProvider) {
    case "arion":
      return "Arion";
    case "aur":
      return "Kvika";
    case "kvika":
      return "Kvika";
    case "lbi":
      return "Landsbankinn";
    case "isb":
      return "Íslandsbanki";
    case "indo":
      return "indó"; // intentionally lowercase
    default:
      return "";
  }
};

export const renderBankIconComponent = (paymentProvider: string) => {
  switch (paymentProvider) {
    case "arion":
      return <Arion height={100} color="#005ab4" />;
    case "aur":
      return <Kvika height={100} color="#907140" />;
    case "kvika":
      return <Kvika height={100} color="#907140" />;
    case "lbi":
      return <LBI height={100} color="#ff0000" />;
    case "isb":
      return <ISB height={100} color="#dc1e35" className="w-38" />;
    case "indo":
      return <Indo height={100} color="#000000" />;
    default:
      return null;
  }
};
